import { MandatiMago } from './../../../model/customer';
import { AdministrativeInfoContainer } from './../../../model/AdministrativeInfo';
import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { AuthorizationProperties } from 'src/app/authentication/auth-info';
import { TranslatedVariables } from 'src/app/commons/translated-variables';
import { LoginService } from 'src/app/core/services/login.service';
import { RolesService } from 'src/app/core/services/roles.service';
import { environment } from 'src/environments/environment';
import { LoadingService } from 'src/app/core/services/loading.service';
import { RolesWeight } from 'src/app/authentication/auth-helpers';
import { CustomerService } from 'src/app/core/services/customer.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { Mode } from 'src/app/model/subscription';
import { CmsObject } from 'src/app/model/cmsobject';
import { CmsService } from 'src/app/core/services/cms.service';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { EntityStatus } from '../subscription-information/subscription-information.component';
import { SubscriptionService } from 'src/app/core/services/subscription.service';
import { StoreRolesService } from 'src/app/core/services/store-role.service';
import { AppSubscription } from 'src/app/model/subscription';
import { IndustryModuleCode, IndustryProductID, ProductCode } from 'src/app/model/industry';
import { ServiceUtilsService } from 'src/app/core/services/service-utils.service';
import { OperationResult } from '@tb/auth';
import { MagoWebService } from 'src/app/core/services/mago-web.service';
import { ConfigurationService } from 'src/app/core/services/configuration.service';

export interface SubscriptionWInstance {
    Description: string;
    InstanceKey: string;
    InstanceDescription: string;
    IsEditable: boolean;
    SubscriptionKey: string;
    Table: string;
    IsClicked: boolean;
    CreationDate: Date;
    NrOfAccounts: number;
    IsRtm: boolean;
    IsOnPrem: boolean;
    Mode: number;
    Status: EntityStatus;
    InstanceOrigin: string;
    MasterSubscriptionKey: string;
}

@Component({
    selector: 'tb-management',
    templateUrl: './subscription-management.component.html',
    styleUrls: ['./subscription-management.component.scss'],
})
export class SubscriptionManagementComponent implements OnInit {
    dataSourceSubscription: MatTableDataSource<SubscriptionWInstance>;
    showSubscriptionTab: boolean = false;
    subscriptionIsDisabled = false;
    authorizationStored = this.loginService.getauthinfo();
    authorizationProperties: AuthorizationProperties = JSON.parse(this.authorizationStored);
    selectedSubscription: string = undefined;
    listOfSubscriptions: SubscriptionWInstance[];
    subscriptionFound: boolean = true;
    searchSubscription: string = '';
    previousSubscription: string;
    isFirstTime: boolean = true;
    hasMoved: boolean = false;
    isDevOpsOrHigher: boolean = false;
    loading = false;
    ifNfs: boolean = false;
    magoCloudInstancesNr: number;
    magoWebInstancesNr: number;
    nfsMessagePremium: string;
    nfsMessageExcellence: string;
    subscriptionDisabledMessage: string;
    partnerCode: string = '';
    model: AppSubscription;
    copyOfModel: AppSubscription;
    subscriptionOperation: Subscription;
    isExcellencePartnerMC: boolean;
    isPremiumPartnerMC: boolean;
    isPlatinumPartnerMW: boolean;
    isGoldPartnerMW: boolean;
    isSilverPartnerMW: boolean;
    public administrativeInfo: Subscription;
    public cmsObj: CmsObject[];
    public disableButtonNFS = true;
    public disableButtonNFSMW = true;

    @Output() descriptionChanged = new EventEmitter<AppSubscription>();

    constructor(
        private subscriptionService: SubscriptionService,
        private loginService: LoginService,
        private rolesService: RolesService,
        private variable: TranslatedVariables,
        private cdr: ChangeDetectorRef,
        public loadingService: LoadingService,
        private activatedRoute: ActivatedRoute,
        public customerService: CustomerService,
        private workFlow: WorkFlowService,
        public cmsService: CmsService,
        public storeRoleService: StoreRolesService,
        private router: Router,
        private serviceUtilsService: ServiceUtilsService,
        private magoWebService: MagoWebService,
        private configurationService: ConfigurationService
    ) {}

    async ngOnInit() {
        await this.getCmsObj();
        this.loading = true;
        this.loadingService.setLoading(this.loading);
        this.administrativeInfo = this.customerService.companyInfo$.subscribe((companyInfo) => {
            if (!companyInfo) return;
            this.isExcellencePartnerMC = AdministrativeInfoContainer.isPlatinumPartner(
                this.customerService.ListOfMandati,
                ProductCode.MAGOCLD
            );
            this.isPlatinumPartnerMW = AdministrativeInfoContainer.isPlatinumPartner(
                this.customerService.ListOfMandati,
                ProductCode.MAGOWEB
            );
            this.isPremiumPartnerMC = AdministrativeInfoContainer.isGoldPartner(this.customerService.ListOfMandati, ProductCode.MAGOCLD);
            this.isGoldPartnerMW = AdministrativeInfoContainer.isGoldPartner(this.customerService.ListOfMandati, ProductCode.MAGOWEB);
            this.isSilverPartnerMW = AdministrativeInfoContainer.isSilverPartner(this.customerService.ListOfMandati, ProductCode.MAGOWEB);

            this.partnerCode = companyInfo.CompanyCode;
        });
        this.isDevOpsOrHigher = this.rolesService.checkRolesMin(RolesWeight.DEVOPS);
        //this.isInternal = this.rolesService.checkRolesMin(RolesWeight.INTERNAL,false);
        this.authorizationStored = this.loginService.getauthinfo();
        this.activatedRoute.queryParams.subscribe((params) => {
            this.ifNfs = params ? params.IDNfs === 'true' : false;
        });
        await this.getSubscriptions();
        this.loading = false;
        this.loadingService.setLoading(this.loading);
    }

    applyFilter(event: any) {
        let filterValue;
        if (event.target) {
            filterValue = (event.target as HTMLInputElement).value;
        } else {
            filterValue = event;
        }
        this.dataSourceSubscription.filterPredicate = function (data, filter: string): boolean {
            return data.Description.toLowerCase().includes(filter) || data.SubscriptionKey.toLowerCase().includes(filter);
        };
        this.dataSourceSubscription.filter = filterValue.trim().toLowerCase();
        if (this.dataSourceSubscription.paginator) {
            this.dataSourceSubscription.paginator.firstPage();
        }
        if (this.dataSourceSubscription.filteredData.length === 0) {
            this.subscriptionFound = false;
        } else {
            this.subscriptionFound = true;
        }
    }

    async getCmsObj() {
        let language = this.workFlow.getLanguageForCms();
        //recupero le stringhe della pagina
        let cmsObj = await this.cmsService.getCmsObj(language, 'store');
        this.nfsMessagePremium = cmsObj.find((x) => x.ContentName == 'store.nfsMessagePremium').ContentTranslation;
        this.nfsMessageExcellence = cmsObj.find((x) => x.ContentName == 'store.nfsMessageExcellence').ContentTranslation;
        this.subscriptionDisabledMessage = cmsObj.find((x) => x.ContentName == 'store.subscriptionDisabledMessage').ContentTranslation;
    }

    async getSubscriptions() {
        let opRes = this.ifNfs
            ? await this.subscriptionService.getSubscriptionsNFS(this.authorizationProperties.accountName, this.partnerCode)
            : await this.subscriptionService.getSubscriptionsWithInstanceKeyToPromise(this.authorizationProperties.accountName);

        if (!opRes.Result) {
            //this.workFlow.showMessage(this.variable.errorTitle, opRes['Message']);
            this.subscriptionFound = false;
            this.loading = false;
            this.loadingService.setLoading(this.loading);
            this.disableButtonNFS = false;
            this.disableButtonNFSMW = false;
            return;
        }
        //ho già la lista filtrata in base al fatto che siano nfs o no
        this.listOfSubscriptions = this.ifNfs
            ? opRes.Content
            : (this.listOfSubscriptions = opRes.Content.filter((x) => x.Mode !== Mode.rnfs));

        if (this.listOfSubscriptions.length == 0) {
            this.subscriptionFound = false;
            this.loading = false;
            this.loadingService.setLoading(this.loading);
            this.disableButtonNFS = false;
            this.disableButtonNFSMW = false;
            return;
        }

        if (this.ifNfs) {
            let nr: number = this.listOfSubscriptions.filter(
                (x) =>
                    !x.IsOnPrem &&
                    x.InstanceOrigin != IndustryProductID.MW &&
                    x.MasterSubscriptionKey !== undefined &&
                    x.MasterSubscriptionKey !== null &&
                    x.MasterSubscriptionKey.length == 0 &&
                    !((x.Status & EntityStatus.Disabled) == EntityStatus.Disabled)
            ).length;
            this.magoCloudInstancesNr = nr;

            let nr_w: number = this.listOfSubscriptions.filter(
                (x) =>
                    !x.IsOnPrem &&
                    x.InstanceOrigin == IndustryProductID.MW &&
                    x.MasterSubscriptionKey !== undefined &&
                    x.MasterSubscriptionKey !== null &&
                    x.MasterSubscriptionKey.length == 0 &&
                    !((x.Status & EntityStatus.Disabled) == EntityStatus.Disabled)
            ).length;
            this.magoWebInstancesNr = nr_w;
        }

        this.disableButtonNFS = await this.setButtonDisabled();
        this.disableButtonNFSMW = await this.setButtonDisabled_MW();
        this.listOfSubscriptions.map((x) => (x.Table = 'subscription'));
        let purchasedSubKey;
        if (!this.ifNfs) {
            if (environment.auth.sessionStorage) {
                purchasedSubKey = sessionStorage.getItem('purchasedSubKey');
            } else {
                purchasedSubKey = localStorage.getItem('purchasedSubKey');
            }

            if (purchasedSubKey) {
                this.selectedSubscription = purchasedSubKey;
            } else {
                this.selectedSubscription = this.listOfSubscriptions[0].SubscriptionKey;
            }
        } else {
            this.selectedSubscription = this.listOfSubscriptions[0].SubscriptionKey;
        }

        this.previousSubscription = this.selectedSubscription;
        this.listOfSubscriptions.filter((x) => x.SubscriptionKey === this.selectedSubscription).map((x) => (x.IsClicked = true));
        this.showSubscriptionTab =
            this.listOfSubscriptions.filter((x) => x.SubscriptionKey === this.selectedSubscription)[0].IsEditable || this.isDevOpsOrHigher;
        let status = this.listOfSubscriptions.filter((x) => x.SubscriptionKey === this.selectedSubscription)[0].Status;
        this.subscriptionIsDisabled = (status & EntityStatus.Disabled) == EntityStatus.Disabled;
        this.dataSourceSubscription = new MatTableDataSource(this.listOfSubscriptions);
        this.cdr.detectChanges();
    }
    async setButtonDisabled() {
        let maxNfsExcellence: OperationResult = await this.serviceUtilsService.getStoreParameterValue('nfs_MaxSubCloudExcellence');
        let maxNfsPremium: OperationResult = await this.serviceUtilsService.getStoreParameterValue('nfs_MaxSubCloudPremium');
        let maxNFSExcellenceNr = +maxNfsExcellence.Content.Value;
        let maxNFSPremiumNr = +maxNfsPremium.Content.Value;

        if (this.isPremiumPartnerMC) return this.ifNfs && this.magoCloudInstancesNr >= maxNFSPremiumNr;
        if (this.isExcellencePartnerMC) return this.ifNfs && this.magoCloudInstancesNr >= maxNFSExcellenceNr;
        else return false;
    }
    public async setButtonDisabled_MW() {
        let maxMWNfsPlatinum: OperationResult = await this.serviceUtilsService.getStoreParameterValue('nfs_MaxSubMWPlatinum');
        let maxMWNfsGold: OperationResult = await this.serviceUtilsService.getStoreParameterValue('nfs_MaxSubMWGold');
        let maxMWNfsSilver: OperationResult = await this.serviceUtilsService.getStoreParameterValue('nfs_MaxSubMWSilver');
        let maxMWNfsDiretta: OperationResult = await this.serviceUtilsService.getStoreParameterValue('nfs_MaxSubMWDiretta');

        let maxMWNFSPlatinumNr = +maxMWNfsPlatinum.Content.Value;
        let maxMNWNFSGoldNr = +maxMWNfsGold.Content.Value;
        let maxMNWNFSSilverNr = +maxMWNfsSilver.Content.Value;
        let maxMWNfsDirettaNr = +maxMWNfsDiretta.Content.Value;
        if (!this.magoWebService.isZucchettiDiretta) {
            if (this.isGoldPartnerMW) return this.ifNfs && this.magoWebInstancesNr >= maxMNWNFSGoldNr;
            if (this.isPlatinumPartnerMW) return this.ifNfs && this.magoWebInstancesNr >= maxMWNFSPlatinumNr;
            if (this.isSilverPartnerMW) return this.ifNfs && this.magoWebInstancesNr >= maxMNWNFSSilverNr;
        } else {
            return this.ifNfs && this.magoWebInstancesNr >= maxMWNfsDirettaNr;
        }
    }
    setSubscription(element: string) {
        if (element === this.selectedSubscription) {
            return;
        }
        this.hasMoved = true;
        let isEditable = this.listOfSubscriptions.filter((x) => x.SubscriptionKey === element)[0].IsEditable;
        this.selectedSubscription = element;
        this.showSubscriptionTab = isEditable || this.isDevOpsOrHigher;
        let status = this.listOfSubscriptions.filter((x) => x.SubscriptionKey === element)[0].Status;
        this.subscriptionIsDisabled = (status & EntityStatus.Disabled) == EntityStatus.Disabled;
        this.changeBackground(element);
    }

    subKeyClicked(subKey: string) {
        // servono per forza entrambe le funzioni ?
        this.setSubscription(subKey);
        this.applyFilter(subKey);
        this.searchSubscription = subKey;
    }

    changeBackground(subKey: any) {
        this.listOfSubscriptions.filter((x) => x.SubscriptionKey === this.previousSubscription).map((x) => (x.IsClicked = false));
        let subscriptionExist = this.listOfSubscriptions.some((x) => x.SubscriptionKey === subKey);
        if (subscriptionExist) {
            this.listOfSubscriptions.filter((x) => x.SubscriptionKey === subKey).map((x) => (x.IsClicked = true));
            this.previousSubscription = this.listOfSubscriptions.filter((x) => x.SubscriptionKey === subKey)[0].SubscriptionKey;
        }
        return;
    }
    public checkVisibility() {
        //è visibile se non è internal e non è un business
        return !this.ifNfs && this.customerService.companyInfo?.Mandato != MandatiMago.SILVER;
    }

    descriptionChange(model: AppSubscription) {
        this.dataSourceSubscription.filteredData
            .filter((x) => x.SubscriptionKey === model.SubscriptionKey)
            .map((x) => (x.Description = model.Description));
    }

    public navigateMagoWeb() {
        if (this.disableButtonNFSMW) return;
        this.router.navigate(['/magoweb-management/magoweb-dashboard'], {
            queryParams: { subscriptionNfs: '1' },
            skipLocationChange: false,
        });
    }
    public async navigateMagoCloud() {
        if (this.disableButtonNFS) return;
        let version = await this.configurationService.getLatestIndustryVersion(IndustryModuleCode.SERD, IndustryProductID.MC);
        this.router.navigate(['/magocloud-management/magocloud-management'], {
            queryParams: {
                subscriptionNfs: '1',
                moduleCode: btoa(IndustryModuleCode.SERD),
                version: btoa(version.toString()),
                productID: btoa(IndustryProductID.MC),
            },
            skipLocationChange: false,
        });
    }
}
